import axios from 'axios';
import snakecaseKeys from 'snakecase-keys';
import settings from '../settings';
export const baseURL = settings.apiUrl;
const aptiveAPI = axios.create({
    baseURL,
});
axios.defaults.headers.common['Content-Type'] = 'application/json';
aptiveAPI.interceptors.request.use((config) => {
    if (config.params) {
        config.params = snakecaseKeys(config.params);
    }
    const token = settings.JWT;
    if (config.headers && token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers['Api-Key'] = 'ff0fd035-9986-4208-9183-677a81c3f94f';
        config.headers['Accept'] = '*/*';
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
}, (err) => {
    return Promise.reject(err);
});
aptiveAPI.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    // handle error code like: 401, 400, 500, etc
    return Promise.reject(error);
});
export default aptiveAPI;
